<template>
  <div>
    <div
      class="mb-3 w-fit px-4 py-2 font-roboto text-[20px] font-medium leading-[24px]"
    >
      {{ shelf.name }}
    </div>
    <div class="relative mb-14 px-8 md:px-5">
      <Swiper
        v-if="shelf"
        :slides-per-view="1"
        :space-between="60"
        :breakpoints="{
          440: {
            spaceBetween: 14,
          },
          768: {
            spaceBetween: 14,
            slidesPerView: 'auto',
          },
        }"
        class="swiper-shelf"
        @swiper="onSwiper"
      >
        <SwiperSlide
          v-for="(book, idx) in shelf.subjects"
          :key="`${book.id}_${idx}`"
          class="swiper-slide card"
        >
          <NuxtLink :to="`/teacher/${book.slug}`">
            <MainPageCardsReworkedTeacherCategoryCard
              :data="book"
              :aspect="aspect"
            />
          </NuxtLink>
        </SwiperSlide>
      </Swiper>

      <SlidersSliderControl
        type="prev"
        class="absolute left-0 top-45% z-10"
        :class="[isBeginning ? 'opacity-50' : 'cursor-pointer']"
        @click="slidePrev()"
      />
      <SlidersSliderControl
        type="next"
        class="absolute right-0 top-45% z-10"
        :class="[isEnd ? 'opacity-50' : 'cursor-pointer']"
        @click="slideNext()"
      />
      <div
        class="top absolute inset-x-0"
        :class="`polka-${!index ? 'top' : 'bottom'}`"
      >
        <div
          class="h-[31px] bg-gradient-to-b from-[rgba(156,156,156,0.05)] to-[rgba(242,242,242,0.57)]"
        ></div>
        <div class="h-[11px] border border-[#ECECEC] bg-[#F4F4F4]"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';
const { onSwiper, slideNext, slidePrev, isEnd, isBeginning } = useSwiper();
const { isMobile } = useBreakpoint();

defineProps({
  shelf: {
    type: Object,
    default: () => ({}),
  },
  index: {
    type: Number,
    default: null,
  },
});

const aspect = computed(() => {
  return !isMobile.value
    ? {
        w: 230,
        h: 263,
      }
    : {
        w: 190,
        h: 227,
      };
});
</script>

<style lang="scss" scoped>
.swiper-shelf {
  @apply px-8 -mb-2;
  padding-bottom: 8px !important;
}
.swiper-slide.card {
  width: 225px !important;
  height: 227px !important;
}
.polka-top {
  @apply bottom-[5px];
}
.polka-bottom {
  @apply bottom-2.5;
}

@media screen and (max-width: 767px) {
  .polka-top {
    @apply bottom-[5px];
  }
  .polka-bottom {
    @apply bottom-2.5;
  }
}

@media screen and (max-width: 415px) {
  .swiper-slide.card {
    width: 100% !important;
    height: 100% !important;
    min-height: 1px;
  }
  .polka-top {
    @apply bottom-0.5;
  }
  .polka-bottom {
    @apply bottom-2.5;
  }
}
</style>
